import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2170">
      <About data-id="element-2171" />
    </main>;
}